import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import PropsType from 'props-type';

import './ToolTip.scss';

const propTypes = {
  children: PropTypes.string,
  leftIcon: PropTypes.element,
};

const defaultProps = {
  children: '',
  leftIcon: <FontAwesomeIcon icon={faExclamationTriangle} />,
};

type ToolTipProps = PropsType<typeof propTypes, typeof defaultProps>;

function ToolTip({ children, leftIcon }: ToolTipProps) {
  if (!children) return null;

  return (
    <div className="ToolTip">
      {leftIcon} <span className="ToolTip__text">{children}</span>
      <div className="ToolTip__triangle">
        <div className="ToolTip__triangle-arrow" />
      </div>
    </div>
  );
}

ToolTip.propTypes = propTypes;
ToolTip.defaultProps = defaultProps;

export default ToolTip;
